
        import 'QuoteHeader.83bd73e.css-module'
        export default {"quoteHeader":"quoteHeader_QuoteHeader_83bd73e"}
    